import { Component, OnInit } from '@angular/core';
import { register } from 'swiper/element/bundle';
import { Swiper } from 'swiper';
import { ApiServiceService } from '../../services/api-service.service';
import { environment } from '../../../environments/environment.development';
import { LoaderService } from '../../services/loader.service';
import { Router } from '@angular/router';

register();

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss']  // Fixed the typo here
})
export class SliderComponent implements OnInit {
  bannerImageUrl = environment.ImageBaseUrl;
  public swiper!: Swiper;
  banerImg: any;

  constructor(
    private api: ApiServiceService,
    private loader: LoaderService,  // Fixed Loader to loader
    private router: Router
  ) {}

  ngOnInit() {
    this.getBanners();
  }
  

  // Convert the image to .webp version
getWebpImage(image: string) {
  if (!image) return '';

  return (this.bannerImageUrl + image)
    .replace('.jpg', '.webp')
    .replace('.jpeg', '.webp')
    .replace('.png', '.webp');
}
  getBanners() {
    this.loader.showLoader();
    this.api.getBanners().subscribe(
      (response: any) => {
        if (Array.isArray(response.data)) {
          this.banerImg = response.data; // Ensure this is an array
        } else {
          this.banerImg = []; // Assign an empty array if not an array
        }
       
        this.loader.hideLoader();
      },
      (error) => {
        console.error('Error fetching banners:', error);
        this.loader.hideLoader();
      }
    );
  }

  getProductById(banner: any) {
    if(banner.referenceType === "Category"){
      this.router.navigate(["product-list", banner.referenceId._id]);
    }else{
      this.router.navigate(['product-details',banner.referenceId._id])
    }
    // this.router.navigate(["product-list", id]);
  }
}
